const initMenuSwipers = () => {
    // MenuBlock exclusive accordion logic - only target top-level direct child details
    document.querySelectorAll('.menu-drawer__accordion-wrap > details').forEach((details) => {
        details.removeEventListener('toggle', handleAccordionToggle);
        details.addEventListener('toggle', handleAccordionToggle);
    });

    // MenuBanner (Swiper) initialization
    if (typeof Swiper === 'undefined') return; // CDN読み込み失敗時は初期化しない
    const menuSwipers = document.querySelectorAll('.menu-drawer-swiper');
    menuSwipers.forEach((swiperEl) => {
        // 既に初期化済みの場合はスキップ
        if (swiperEl.classList.contains('swiper-initialized')) return;

        const container = swiperEl.closest('.menu-drawer__swiper-container');
        const progressFill = container ? container.querySelector('.menu-drawer-swiper-progress-fill') : null;
        const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

        const swiper = new Swiper(swiperEl, {
            loop: slideCount > 1,
            speed: 1200,
            autoplay: slideCount > 1 ? {
                delay: 5000,
                disableOnInteraction: false,
            } : false,
            on: {
                init: function () {
                    if (slideCount > 1) updateProgress(this, progressFill);
                },
                slideChange: function () {
                    if (slideCount > 1) updateProgress(this, progressFill);
                }
            }
        });
    });
};

const handleAccordionToggle = (e) => {
    const details = e.currentTarget;
    if (details.open) {
        document.querySelectorAll('.menu-drawer__accordion-wrap > details').forEach((other) => {
            if (other !== details && other.open) {
                other.open = false;
            }
        });
    }
};

function updateProgress(swiper, fillEl) {
    if (!fillEl) return;
    const realSlides = Array.from(swiper.slides).filter(slide => !slide.classList.contains('swiper-slide-duplicate'));
    const total = realSlides.length;
    if (total <= 1) {
        fillEl.style.width = '0%';
        return;
    }
    const current = swiper.realIndex + 1;
    const progress = (current / total) * 100;
    fillEl.style.width = progress + '%';
}

document.addEventListener('DOMContentLoaded', initMenuSwipers);
document.addEventListener('shopify:section:load', initMenuSwipers);
